import { FormikProvider } from 'formik'
import { useTranslation } from 'react-i18next'
import { Box, Divider, IconButton, Paper, Typography } from '@mui/material'

import { ChevronRight } from '@mui/icons-material'
import HeaderProfileDetails from './header.component'
import FieldsProfileDetails from './fields.component'

import ActionsProfileDetails from './actions.component'
import useEditProfile from '../hooks/use-edit-profile.hook'

const ProfileDetails = () => {
  const { t } = useTranslation()

  const {
    loggedUser,
    formikDetails,
    brandsOptions,
    showEditProfile,
    handleOnSave,
    handleOnCancel,
    handleShowTwoEditProfile,
  } = useEditProfile()

  return (
    <Box mb={3} mt={6} component={Paper} p={2}>
      <HeaderProfileDetails loggedUser={loggedUser} />
      <Divider light />
      {showEditProfile ? (
        <>
          <FormikProvider value={formikDetails}>
            <FieldsProfileDetails
              loggedUser={loggedUser}
              brandsOptions={brandsOptions}
            />
          </FormikProvider>
          <ActionsProfileDetails
            handleOnCancel={handleOnCancel}
            handleOnSave={handleOnSave}
            disableActions={!(formikDetails.dirty && formikDetails.isValid)}
          />
        </>
      ) : (
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mt={2}
          mb={3}
        >
          <Typography component="p">{t('profile.editProfile')}</Typography>
          <Box width={30}>
            <IconButton onClick={() => handleShowTwoEditProfile()}>
              <ChevronRight />
            </IconButton>
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default ProfileDetails
